function CSVImportCtrl($scope,$controller,$location,Upload, $state) {

    $scope.wizardDef = {
        url:  "/csvStepData?type=" + $scope.$parent.type,
        steps : [
            {name:"fields",label:"Required Fields"},
            {name:"upload",label:"Upload CSV"},
            {name:"finish",label:"Finish","interval":500}
        ]
    };


    $scope.upload = function (files) {
        if (files && files.length) {
            for (var i = 0; i < files.length; i++) {
                var file = files[i];
                Upload.upload({
                    url: "csvUpload?type=" +  $location.search()["type"] + "&accountId=" +  $state.params.accountId,
                    file: file
                }).progress(function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    console.log('progress: ' + progressPercentage + '% ' + evt.config.file.name);
                }).success(function (data, status, headers, config) {
                    console.log('file ' + config.file.name + 'uploaded. Response: ' + data);
                });
            }
        }
    };
}

